<template>
    <div class="tile-content tile-content-secondary text-center" v-fs-block>
        <v-error-messages class="stack-l">
            {{ errorMessage }}
        </v-error-messages>
        <v-file-selector @input="updateImage">
            <template slot-scope="{openFileBrowser}">
                <div v-show="hasImageData || hasContent" class="stack-m">
                    <img class="image image-logo image-center" ref="imagePreview"/>
                    <r-button @click="openFileBrowser" type="link">Change Logo</r-button><span class="text-muted">&nbsp;&nbsp;|&nbsp;&nbsp;</span><r-button @click="removeLogo" type="link">Remove Logo</r-button>
                </div>
                <div v-if="!hasImageData && !hasContent" @click="openFileBrowser" class="cursor-pointer">
                    <img class="image image-128 image-center" src="/static/icons/blank-state/upload-blank-state-icon.svg"/>
                    <h3 class="text-muted">Upload your logo</h3>
                </div>
            </template>
        </v-file-selector>
        <p class="text-muted">Allowed file extensions: {{ allowedExtensionsLabel }}. Max file size: {{ maxFileSize | bytes }}</p>
    </div>
</template>

<script>
    import _ from '@/common/helpers/index';
    import vFileSelector from './v-file-selector';
    import vErrorMessages from './v-error-messages';

    export default {
        name: 'upload-logo',
        components: {
            vFileSelector,
            vErrorMessages,
        },
        data() {
            return {
                maxFileSize: 20480 * 1024,
                allowedExtensions: ['png', 'jpg', 'jpeg'],
                image: null,
                errorMessage: null,
            };
        },
        props: {
            previewUrl: {
                type: String,
            },
        },
        computed: {
            hasContent() {
                return !_.isBlank(this.previewUrl);
            },
            hasImageData() {
                return this.errorMessage === null && this.image !== null;
            },
            allowedExtensionsLabel() {
                if (this.allowedExtensions) {
                    return this.allowedExtensions.join(', ');
                }
                return '';
            },
        },
        methods: {
            updateImage(files) {
                const [image = false] = files;
                if (image && this.validateFile(image) && window.URL) {
                    this.$nextTick(() => {
                        this.$refs.imagePreview.setAttribute('src', URL.createObjectURL(image));
                        this.image = this.$refs.imagePreview.src;
                        this.$emit('update', image);
                    });
                }
            },
            validateFile(file) {
                const [extension] = file.name.split('.').reverse();
                if (!this.allowedExtensions.includes(extension)) {
                    this.errorMessage = `The extension of your selected file (${file.name}) is invalid (allowed file formats: ${this.allowedExtensionsLabel})`;
                    return false;
                } if (file.size > this.maxFileSize) {
                    this.errorMessage = `The size of your selected file (${file.name} - ${this.$filters.bytes(file.size)}) is too large (max file size: ${this.$filters.bytes(this.maxFileSize)}).`;
                    return false;
                }
                this.errorMessage = null;
                this.image = null;
                return true;
            },
            loadPreviewFromFiles() {
                try {
                    this.$refs.imagePreview.src = this.previewUrl;
                } catch (err) {
                    this.$emit('no-logo');
                }
            },
            removeLogo(evt) {
                this.$emit('no-logo');
                this.image = null;
                this.$refs.imagePreview.src = null;
                evt.preventDefault();
            },
        },
        mounted() {
            this.loadPreviewFromFiles();
        },
    };
</script>
